<template>
  <div class="step-a-wrapper">

    <div><h3 class="mb-20" style="color: #1890ff;">Section 1: General Data</h3></div>
    <a-form layout="vertical" :form="formStepA">

      <!-- Q1 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24">
          <h6 class="font-web mt-0 mb-0">1. General Information</h6>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Name</span>
            </template>
            <a-select v-model="form.name" show-search placeholder="Select..." v-decorator="[
              'form.name',
              { rules: [{ required: true, message: 'Please input your Name' }] },
            ]">
              <a-select-option value="Mr">(1) Mr.</a-select-option>
              <a-select-option value="Ms">(2) Ms.</a-select-option>
              <a-select-option value="Miss">(3) Miss.</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Surname</span>
            </template>
            <a-input v-model="form.surname" v-decorator="[
              'form.surname',
              { rules: [{ required: true, message: 'Please input your Surname' }] },
            ]" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Student Number / Code</span>
            </template>
            <a-input v-model="form.studentCode" v-decorator="[
              'form.studentCode',
              { rules: [{ required: true, message: 'Please input your Student Number / Code' }] },
            ]" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Faculty</span>
            </template>
            <a-input v-model="form.faculty" v-decorator="[
              'form.faculty',
              { rules: [{ required: true, message: 'Please input your Faculty' }] },
            ]" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="[16, 16]">
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Major Subject</span>
            </template>
            <a-input v-model="form.major" v-decorator="[
              'form.major',
              { rules: [{ required: true, message: 'Please input your major' }] },
            ]" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Email</span>
            </template>
            <a-input v-model="form.email" v-decorator="[
              'form.email',
              {
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                  {
                    required: true,
                    message: 'Please input your E-mail!',
                  },
                ],
              },
            ]" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :md="6">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">Phone number</span>
            </template>
            <a-input v-model="form.phone" :value="form.phone" :max-length="10"
              placeholder="กรุณากรอกข้อมูล (กรณีไม่มี ให้ระบุ -)" 
              v-decorator="[
                'form.phone',
                { initialValue: form.phone, rules: [{ required: true, validator: onChangeLockNumber }] },
              ]" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q2 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24">
          <h6 class="font-web mt-0 mb-0">2. Place of Birth (Province)</h6>
        </a-col>
        <a-col :xs="24" :sm="24" :md="18">
          <a-form-item label="">
            <a-input v-model="form.birthProvince" v-decorator="[
              'form.birthProvince',
              { rules: [{ required: true, message: 'Please input your Province' }] },
            ]" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q3 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24">
          <h6 class="font-web mt-0 mb-0">3. Military Status (Male only)</h6>
        </a-col>
        <a-col :xs="24" :sm="24" :md="18">
          <a-form-item label="">
            <a-select 
              v-decorator="[
                'form.militaryStatus',
                { initialValue: form.militaryStatus, rules: [{ required: true, message: 'Please select your Military Status' }] },
              ]" 
              v-model="form.militaryStatus" 
              placeholder="Select ..."
            >
                <a-select-option value="-">-</a-select-option>
                <a-select-option value="0">(0) Taken a draft deferment period / Exempted / Conscripted</a-select-option>
                <a-select-option value="1">(1) Serving in military</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q4 -->
      <a-row :gutter="[16, 16]">
        <a-col :xs="24">
          <h6 class="font-web mt-0 mb-0">4. Being Ordained as a Priest Status</h6>
        </a-col>
        <a-col :xs="24" :sm="24" :md="18">
          <a-form-item label="">
            <a-select 
              v-decorator="[
                'form.priestStatus',
                { initialValue: form.priestStatus, rules: [{ required: true, message: 'Please select Being Ordained as a Priest Status' }] },
              ]" 
              v-model="form.priestStatus" 
              placeholder="Select ..."
            >
              <a-select-option value="1">(1) Not being as a priest</a-select-option>
              <a-select-option value="2">(2) Being as a priest and will disrobe in 3 months</a-select-option>
              <a-select-option value="3">(3) Being as a priest and will disrobe in 4 - 12 months</a-select-option>
              <a-select-option value="4">(4) Being as a priest and will disrobe more than 1 year</a-select-option>
              <a-select-option value="5">(5) Being as a priest and do not have a plan to disrobe</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <!-- Q5 -->
      <a-row :gutter="[24, 24]">
        <a-col :xs="24">
          <h6 class="font-web mt-0 mb-0">5. Currently Employed Status</h6>
        </a-col>
        <a-col :xs="24" :sm="24" :md="18">
          <a-form-item label="">
            <a-select 
               
              @change="handleEmployedStatusChange"
              
              v-decorator="[
                'form.employedStatus',
                { initialValue: form.employedStatus, rules: [{ required: true, message: 'Please select Currently Employed Status' }] },
              ]" 
              show-search
              placeholder="Select..."
            >
              <a-select-option value="1">(1) Unemployed before graduation and be employed after
                graduation</a-select-option>
              <a-select-option value="2">(2) Be employed and currently continue in greater degree</a-select-option>
              <a-select-option value="3">(3) Unemployed (go to section 3)</a-select-option>
              <a-select-option value="4">(4) Unemployed and currently continue in greater degree (go to section
                4)</a-select-option>
              <a-select-option value="5">(5) Be employed in the same field before and after graduation</a-select-option>
              <a-select-option value="6">(6) Be employed before and change the field work after
                graduation</a-select-option>
              <a-select-option value="7">(7) Be employed before graduation and promoted after graduation in the same
                field</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

    </a-form>

    <!-- controll -->
    <div class="text-right">
      <a-button @click="submitAndValidateA" type="primary"> Go forward<a-icon type="right" /> </a-button>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formStepA: this.$form.createForm(this, { name: 'stepA' }),
      form: {
        name: '',
        surname: '',
        studentCode: '',
        faculty: '',
        major: '',
        email: '',
        phone: '',
        birthProvince: '',
        militaryStatus: null,
        priestStatus: null,
        employedStatus: null
      }
    };
  },
  mounted() { },
  methods: {
    handleEmployedStatusChange(val) {
      this.form.employedStatus = val;
      this.formStepA.validateFields((err, values) => {
        if (!err) {
          this.$emit('updateData', 'stepA', { ...this.form, ...values.form, employedStatus: val });
          if (val === '3') {
            setTimeout(() => { this.$emit('NextSectionSkip', 2); }, 400);
          } else if (val === '4') {
            setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400);
          }
        }
      });
    },

    // validate Condition
    onChangeLockNumber(rule, value, callback) {
      const reg = /^-?[0-9]*(\.[0-9]*)?$/;
      if (![''].includes(value)) {
        if ((!isNaN(value) && reg.test(value))) {
          callback();
          return;
        }
        callback('กรุณากรอกข้อมูล (กรณีไม่มี ให้ระบุ -)');
      } else {
        callback('กรุณากรอกข้อมูล (กรณีไม่มี ให้ระบุ -)');
      }
    },
    submitAndValidateA() {
      this.formStepA.validateFields((err, values) => {
        if (!err) {
          const status = this.form.employedStatus || values.form?.employedStatus || values.employedStatus;
          this.$emit('updateData', 'stepA', { ...this.form, ...values.form, employedStatus: status });
          if (status === '3') {
            setTimeout(() => { this.$emit('NextSectionSkip', 2); }, 400);
          } else if (status === '4') {
            setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400);
          } else {
            setTimeout(() => { this.$emit('NextSectionSkip', 1); }, 400);
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.step-a-wrapper {
  padding: 20px;
}
</style>